import { ThemeColors } from '~/themes/colors'

export interface AudioPlayerColors {
  Background: ThemeColors
  BoxShadow: ThemeColors
  ControlButton: {
    Background: {
      Default: ThemeColors
    }
    Icon: {
      Hover: ThemeColors
    }
  }
  PlayButton: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
  PauseButton: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
  Title: {
    FontColor: ThemeColors
    IconColor: ThemeColors
  }
  Handle: {
    Background: ThemeColors
    Border: ThemeColors
  }
  Track: {
    Played: ThemeColors
    Unplayed: ThemeColors
  }
  Timestamp: {
    FontColor: ThemeColors
  }
}

export const audioPlayerColors: AudioPlayerColors = {
  Background: {
    default: 'gray.100',
  },
  BoxShadow: {
    default: 'mask.black.20',
  },
  ControlButton: {
    Background: {
      Default: {
        default: 'achromatic.transparent',
      },
    },
    Icon: {
      Hover: {
        default: 'gray.1300',
      },
    },
  },
  PlayButton: {
    Background: {
      Default: {
        default: 'gray.300',
      },
      Hover: {
        default: 'gray.400',
      },
      Active: {
        default: 'blue.300',
      },
    },
  },
  PauseButton: {
    Background: {
      Default: {
        default: 'blue.900',
      },
      Hover: {
        default: 'blue.700',
      },
      Active: {
        default: 'blue.900',
      },
    },
  },
  Title: {
    FontColor: {
      default: 'gray.1300',
    },
    IconColor: {
      default: 'gray.1300',
    },
  },
  Handle: {
    Background: {
      default: 'blue.900',
    },
    Border: {
      default: 'gray.100',
    },
  },
  Track: {
    Played: {
      default: 'blue.700',
    },
    Unplayed: {
      default: 'gray.400',
    },
  },
  Timestamp: {
    FontColor: {
      default: 'gray.1300',
    },
  },
}
